// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3hQlk","addWidgetButton":"Header_addWidgetButton__28wDM","dashboardTabs":"Header_dashboardTabs__1znkq","active":"Header_active__2iYSW"};